import { Component, OnInit, Input, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { SharedService } from 'src/app/modules/shared/_services/shared.service';

@Component({
  selector: 'app-common-side-card',
  templateUrl: './common-side-card.component.html',
  styleUrls: ['./common-side-card.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class CommonSideCardComponent implements OnInit {

  @Input() TenderByKeywords: any[] = [];
  @Input() TenderByCities: any[] = [];
  showAllTenderByKeywords = false;
  showAllTenderByCities = false;
  TenderByKeywordsAccordion = [true];
  tenderByCitiesAccordion = [true];
  baseUrl = environment.TENDER.BASE_URL;
  isMobileCheck: any;

  get visibleTenderByKeywords() {
    return this.showAllTenderByKeywords ? this.TenderByKeywords : this.TenderByKeywords?.slice(0, 5);
  }

  get visibleTenderByCities() {
    return this.showAllTenderByCities ? this.TenderByCities : this.TenderByCities?.slice(0, 5);
  }

  constructor(private router: Router, private sharedService: SharedService) {
    this.checkScreenSize();
    if (this.sharedService.isBrowser) {
      window.addEventListener('resize', () => this.checkScreenSize());
    }
  }

  ngOnInit(): void { }

  private checkScreenSize() {
    if (this.sharedService.isBrowser) {
      if (typeof window !== 'undefined') {
        const isMobile = window.innerWidth <= 1199; // Adjust the breakpoint as needed
        if (isMobile) {
          this.isMobileCheck = true;
        } else {
          this.isMobileCheck = false;
        }
      } else {
        this.isMobileCheck = false;
      }
    }
  }

  navigateToTender(link: string, event: MouseEvent) {
    event.preventDefault();
    this.router.navigate([`/${link}-tenders/active`]);
  }

  toggleViewTenderByKeywords() {
    this.showAllTenderByKeywords = !this.showAllTenderByKeywords;
  }

  toggleViewTenderByCities() {
    this.showAllTenderByCities = !this.showAllTenderByCities;
  }

  TenderByKeywordsToggle(index: number) {
    this.TenderByKeywordsAccordion[index] = !this.TenderByKeywordsAccordion[index];
  }

  tenderByCitiesToggle(index: number) {
    this.tenderByCitiesAccordion[index] = !this.tenderByCitiesAccordion[index];
  }

}




